// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"155": "__federation_expose_PatientReception","558": "__federation_expose_AppointmentCalendar","673": "__federation_expose_ProfessorSchedule","974": "__federation_expose_ProfessorScheduleAdmin",}[chunkId] + "." + {"155": "d770c181","558": "5c60fb8c","673": "8321b077","974": "44deacc5",}[chunkId] + ".css"
}